import { createContext, useContext, useState } from 'react';

export interface NavContextData {
  defaultFooter: boolean;
  footer: boolean;
  adminBgColor?: string;
  blueTopArch?: boolean;
}

export interface NavContextFullData extends NavContextData {
  setNavContext<T extends keyof NavContextData>(key: T, value: NavContextData[T]): void;
}

const defaultData: NavContextFullData = {
  defaultFooter: true,
  footer: true,
  adminBgColor: 'bg-gray-100',
  setNavContext: () => {},
};

export const NavContext = createContext<NavContextFullData>(defaultData);
export function NavProvider({ children }: { children: React.ReactNode }) {
  const [data, setData] = useState<NavContextData>(defaultData);
  return <NavContext.Provider value={{ ...data, setNavContext }}>{children}</NavContext.Provider>;

  function setNavContext<T extends keyof NavContextData>(key: T, value: NavContextData[T]) {
    setData({ ...data, [key]: value });
  }
}

export function useNavContext() {
  const context = useContext(NavContext);
  if (context === undefined) throw new Error('useNavContext must be used within a NavContextProvider');
  return context;
}
